(function () {
  'use strict';

  function initCOA(root) {
    if (!root || root.dataset.coaReady === 'true') return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-coa-tab]'));
    var resultsPanel = root.querySelector('[data-coa-panel="results"]');
    var gallery = root.parentElement ? root.parentElement.querySelector('[data-elite-gallery]') : document.querySelector('[data-elite-gallery]');
    var coaImages = Array.prototype.slice.call(root.querySelectorAll('[data-coa-index]'));
    var prev = root.querySelector('[data-coa-prev]');
    var next = root.querySelector('[data-coa-next]');
    var counter = root.querySelector('[data-coa-counter]');
    if (!tabs.length) return;

    var currentCOA = 0;
    function updateCounter() { if (counter && coaImages.length) counter.textContent = (currentCOA + 1) + ' / ' + coaImages.length; }
    function showCOA(index) {
      if (!coaImages.length) return;
      currentCOA = Math.max(0, Math.min(index, coaImages.length - 1));
      coaImages.forEach(function(img, i) { img.classList.toggle('is-active', i === currentCOA); });
      updateCounter();
    }
    function setMode(mode) {
      var results = mode === 'results';
      tabs.forEach(function(tab) {
        var active = tab.getAttribute('data-coa-tab') === mode;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (gallery) gallery.hidden = results;
      if (resultsPanel) resultsPanel.hidden = !results;
      if (results) showCOA(currentCOA);
    }
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); setMode(tab.getAttribute('data-coa-tab')); });
    });
    if (prev) prev.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); showCOA((currentCOA - 1 + coaImages.length) % coaImages.length); });
    if (next) next.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); showCOA((currentCOA + 1) % coaImages.length); });
    coaImages.forEach(function(img, index) { img.addEventListener('click', function() { showCOA(index); }); });

    root.dataset.coaReady = 'true';
    setMode('product');
  }

  function bootCOA() { document.querySelectorAll('[data-coa-tab-controller]').forEach(initCOA); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootCOA); else bootCOA();
  document.addEventListener('shopify:section:load', bootCOA);
  document.addEventListener('shopify:section:select', bootCOA);
  document.addEventListener('shopify:section:reorder', bootCOA);
})();
